const gbTranslation = () => {
    return {
        common: {
            edit: 'Edit',
            create: 'Create',
            save: 'Save',
            update: 'Update',
            saving: 'Saving...',
            cancel: 'Cancel',
            delete: 'Delete',
            search: 'Search',
            title: 'Title',
            description: 'Description',
            intensity: 'Intensity',
            areYouSure: 'Are you sure?',
            none: 'None',
            all: 'All',
            sessionExpired: 'Your session has expired',
            errorOccurred: 'An error occurred',
            success: 'Success',
            error: 'Error',
            warning: 'Warning',
            info: 'Information',
            confirm: 'Confirm',
            back: 'Back',
            next: 'Next',
            previous: 'Previous',
            loading: 'Loading...',
            noData: 'No data available',
            actions: 'Actions',
            close: 'Close',
            submit: 'Submit',
            reset: 'Reset',
            requiredField: 'This field is required',
            invalidEmail: 'Invalid email',
            invalidPhone: 'Invalid phone number',
            invalidUrl: 'Invalid URL',
            invalidDate: 'Invalid date',
            invalidTime: 'Invalid time',
            invalidDatetime: 'Invalid date and time',
            invalidNumber: 'Invalid number',
            invalidInteger: 'Invalid integer',
            invalidDecimal: 'Invalid decimal',
            invalidPassword: 'Invalid password',
            invalidConfirmPassword: 'Passwords do not match',
            invalidMinLength: 'Must be at least {min} characters',
            invalidMaxLength: 'Must not exceed {max} characters',
            active: 'Active',
            status: 'Status',
            showCompleted: 'Show completed',
            completed: 'Completed',
        },
        faq: {
            title: 'Frequently Asked Questions',
            noFaq: 'No frequently asked questions available at the moment.',
            deleteSuccess: 'The question has been successfully deleted',
            deleteError: 'An error occurred while deleting the question',
            updateSuccess: 'The question has been successfully updated',
            manage: 'Frequently Asked Questions Management',
            edit: 'Edit question',
            create: 'Create a question',
            createSuccess: 'Question created successfully',
            categories: {
                all: 'All categories',
                general: 'General',
                account: 'Account',
                subscription: 'Subscription',
                payment: 'Payment',
                other: 'Other',
            },
            form: {
                question: 'Question',
                answer: 'Answer',
                category: 'Category',
                order: 'Display order',
                isActive: 'Active',
                newQuestion: 'New question',
                editQuestion: 'Edit question',
                createSuccess: 'Question created successfully',
                updateSuccess: 'Question updated successfully',
                deleteSuccess: 'Question deleted successfully',
                deleteConfirm: 'Are you sure you want to delete this question?',
                validation: {
                    questionRequired: 'Question is required',
                    answerRequired: 'Answer is required',
                    categoryRequired: 'Category is required',
                },
            },
            filter: {
                category: 'Filter by category',
                showInactive: 'Show inactive questions',
            },
            invalidMinValue: 'Must be greater than or equal to {min}',
            invalidMaxValue: 'Must be less than or equal to {max}',
            markAsComplete: 'Mark as complete',
            markAsIncomplete: 'Mark as incomplete',
            inactive: 'Inactive',
            lastUpdated: 'Last updated',
            completed: 'Completed',
            invalidPattern: 'Invalid format',
            invalidRequired: 'This field is required',
            invalidUrlFormat: 'Invalid URL format',
            invalidEmailFormat: 'Invalid email format',
            invalidPhoneFormat: 'Invalid phone format',
            invalidDateRange: 'End date must be after start date',
            invalidTimeRange: 'End time must be after start time',
            invalidDatetimeRange: 'End date and time must be after start date and time',
        },
        global: {
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            sunday: 'Sunday',
            lang: {
                fr: 'French',
                gb: 'English',
                br: 'Brazil',
            },
            back: 'Back',
        },
        home: {
            'main-title': "Badminton Villeneuve d'Ascq",
            'presentation-1': 'Youngs and adults, competitors et leisure, ',
            'presentation-2': 'the ',
            'presentation-3': 'BVA',
            'presentation-4': ' the BVA supports all badminton players to have fun.',
            'last-news': 'Last news',
        },
        header: {
            menu: {
                home: 'Home',
                planning: 'Planning & Prices',
                registration: 'Sign up',
                competition: 'Tournaments',
                contact: 'Contact us',
                faq: 'FAQ',
                'my-space-bva': 'My BVA space',
                login: 'Sign in',
                connect: 'Sign in',
                'go-to-member-space': 'Go to member space',
                'go-to-coach-space': 'Go to coach space',
                'go-to-admin-space': 'Go to admin space',
                'forgot-password': 'Forgot password?',
                'pseudo-received-by-email': 'Username * (received by email)',
                'enter-email-or-pseudo': 'Enter your email or username',
                'enter-password': 'Enter your password',
                email: 'Email address',
                'email-placeholder': 'Enter your email address',
                'pseudo-placeholder': 'Enter your username',
                'reset-password': 'Password Reset',
                'reset-password-email-sent': 'A reset email has been sent',
                'send-email': 'Send Email',
                member: 'Member',
                coach: 'Coach',
                admin: 'Administrator',
                connexion: 'Login',
                'account-type': 'Account Type',
                'select-account-type': 'Select an account type',
            },
        },
        footer: {
            copyright: `Copyright © ${new Date().getFullYear()}. All rights reserved - Site created by`,
            administration: 'Administration',
        },
        sidebar: {
            admin: {
                dashboard: 'Dashboard',
                user: 'User',
                news: 'News',
                competition: 'Tournaments',
                plannings: 'Plannings',
                prices: 'Prices',
                documentation: 'Documentation',
                'to-document-myself': 'To document myself',
                coachs: 'Coachs',
                faq: 'FAQ',
                'training-sessions': 'Training sessions',
                'training-session-groups': 'Training session groups',
            },
            member: {
                'my-progression': 'My progression',
                password: 'Password',
                'satisfaction-survey': 'Satisfaction Survey',
            },
        },
        admin: {
            dashboard: 'Dashboard',
            or: 'or',
            'search-member-input': '🔍 Search a member',
            'search-coach-input': '🔍 Search a coach',
        },
        coach: {
            dashboard: 'Dashboard',
            'my-members': 'My members',
            'my-sessions': 'My sessions',
            'members-added': 'Members added',
            skills: 'Skills',
            'skill-already-exist': 'Skill already exist',
            'skill-deleted': 'Skill deleted',
            'add-skill': 'Add skill',
            'skill-edited': 'Skill edited',
            'members-removed': 'Members removed',
            '4-players-with-most-missings': '4 players with most missings',
            'skills-least-mastered': 'Skills least mastered',
            noGroupsWithMembers: 'No groups with members found',
            noPlayersWithMissings: 'No players with missings in this group',
            noSkillsToDisplay: 'No skills to display for this group',
            trainingSessionGroups: {
                title: 'Training Session Groups',
                createTitle: 'Create Group',
                editTitle: 'Edit Group',
                members: 'Members',
                deleteSuccess: 'Group deleted successfully',
                deleteError: 'An error occurred while deleting the group',
                createSuccess: 'Group created successfully',
                createError: 'An error occurred while creating the group',
                updateSuccess: 'Group updated successfully',
                updateError: 'An error occurred while updating the group',
                form: {
                    title: 'Title',
                    description: 'Description',
                },
                filters: {
                    search: 'Search',
                    searchPlaceholder: 'Search a group...',
                },
                shareWithCoaches: 'Share with coaches',
                shareWithCoachesHelp: 'Select coaches to share this session group with',
            },
            trainingSessions: {
                title: 'My Training Sessions',
                filterByIntensity: 'Filter by intensity',
                noSessions: 'No sessions found',
                steps: 'Steps',
                startTime: 'Start time',
                endTime: 'End time',
                createdSuccess: 'Session has been created successfully',
                updatedSuccess: 'Session has been updated successfully',
                exercise: 'Exercise',
                addStep: 'Add step',
                deleteSuccess: 'Session deleted successfully',
                deleteError: 'An error occurred while deleting the session',
                createSuccess: 'Session created successfully',
                createError: 'An error occurred while creating the session',
                updateSuccess: 'Session updated successfully',
                updateError: 'An error occurred while updating the session',
                toggleCompleteSuccess: 'Session status updated successfully',
                toggleCompleteError: 'An error occurred while updating the session status',
                session: 'session',
                newSession: 'New Session',
                editSession: 'Edit Session',
                viewMembers: 'View members',
                groupMembers: 'Group members',
                description: 'Description',
                intensity: 'Intensity',
                intensityLow: 'Low',
                intensityMedium: 'Medium',
                intensityHigh: 'High',
                intensityVeryHigh: 'Very high',
                intensityExtreme: 'Extreme',
                group: 'Group',
                noGroup: 'No group',
                groupPlaceholder: 'Select a group',
                groupHelp: 'Optional - Associate this session with an existing group',
                sessionDescriptionPlaceholder: 'Describe the session content...',
                sessionTitlePlaceholder: 'Enter session title',
                sessionSteps: 'Session Steps',
                stepTitle: 'Title *',
                stepStartTime: 'Start time',
                stepEndTime: 'End time',
                stepExercise: 'Associated Exercise (optional)',
                stepDescription: 'Description (optional)',
                noExercise: 'No exercise',
                addStepButton: 'Add a step',
                deleteStep: 'Delete this step',
                step: 'Step',
                stepNumber: 'Step {{number}}',
                moveUp: 'Move up',
                moveDown: 'Move down',
                viewExercise: 'View exercise details',
                generateExercise: 'Generate exercise',
                loading: '...',
                errors: {
                    titleRequired: 'Title is required',
                    stepTitleRequired: 'Step {{index}} title is required',
                    invalidTimeRange: 'End time must be after start time (step {{index}})',
                    overlappingSteps: 'Steps {{step1}} and {{step2}} overlap',
                    authRequired: 'Authentication required',
                    genericError: 'An error occurred',
                    errorOccurred: 'An error occurred',
                    sessionRequired: 'Session required',
                },
            },
            exercises: {
                title: 'Exercises',
                addExercise: 'Add an exercise',
                searchPlaceholder: 'Search an exercise...',
                filters: {
                    intensity: 'Intensity',
                    gameType: 'Game type',
                    courtType: 'Court type',
                    peopleCount: 'Number of people',
                    skills: 'Skills',
                    all: 'All',
                    gameTypeSingles: 'Singles',
                    gameTypeDoubles: 'Doubles',
                    gameTypeBoth: 'Both',
                    courtTypeFull: 'Full',
                    courtTypeHalf: 'Half court',
                    courtTypeBoth: 'Both',
                },
                exerciseItem: {
                    people: 'person',
                    people_plural: 'people',
                    intensity: 'Intensity:',
                    gameType: 'Game type:',
                    courtType: 'Court type:',
                    skills: 'Skills:',
                    intensityEnum: {
                        LOW: 'Low',
                        MEDIUM: 'Medium',
                        HIGH: 'High',
                    },
                    gameTypeEnum: {
                        SINGLES: 'Singles',
                        DOUBLES: 'Doubles',
                        BOTH: 'Both',
                    },
                    courtTypeEnum: {
                        FULL: 'Full',
                        HALF: 'Half court',
                        BOTH: 'Both',
                    },
                },
                createSuccess: 'Exercise created successfully',
                createError: 'An error occurred while creating the exercise',
                updateSuccess: 'Exercise updated successfully',
                updateError: 'An error occurred while updating the exercise',
                deleteSuccess: 'Exercise deleted successfully',
                deleteError: 'An error occurred while deleting the exercise',
                deleting: 'Deleting...',
                exercise: 'an exercise',
                description: 'Description',
                peopleCount: 'Number of people',
                intensity: 'Intensity',
                intensityLow: 'Low',
                intensityMedium: 'Medium',
                intensityHigh: 'High',
                gameType: 'Game type',
                gameTypeSingles: 'Singles',
                gameTypeDoubles: 'Doubles',
                gameTypeBoth: 'Both',
                courtType: 'Court type',
                courtTypeFull: 'Full',
                courtTypeHalf: 'Half court',
                courtTypeBoth: 'Both',
                skills: 'Skills',
                generatedFrom: 'Generated from',
                generateSuccess: 'Exercise generated and associated successfully',
                generateError: 'An error occurred while generating the exercise',
            },
            parentSkills: 'Skill categories',
            'skill-create-error': 'An error occurred while creating the category',
            'skill-edit-error': 'An error occurred while updating the category',
            'skill-delete-error': 'An error occurred while deleting the category',
            'skill-created': 'Category created successfully',
            'skill-updated': 'Category updated successfully',
        },
        member: {
            dashboard: 'Dashboard',
            'my-followed-skills': 'My followed skills',
            'my-progression': 'My progression',
            'my-skills': 'My skills',
            documentation: 'Documentation',
            'search-document-input': '🔍 Search a document',
            'search-skill-input': '🔍 Search a skill',
            'satisfaction-survey': 'Satisfaction Survey',
            'satisfaction-survey-iframe-fallback': 'The satisfaction survey cannot be displayed. Please click this link to access it.',
            'notify-skill-changes': 'Receive email notifications when my skills are updated',
            'notification-preference-updated': 'Notification preference updated successfully',
            'welcome-1': 'Hello {{ user.firstname }} {{ user.lastname }},',
            'welcome-2': 'Welcome to your BVA account',
            'welcome-4': 'In the future, new features may be introduced.',
            'welcome-5':
                "If you have any ideas on how to improve the website, don't hesitate to send them to the following e-mail address: president@bva-club.fr.",
            'last-news': 'Latest news',
            'edit-password': 'Change my password',
            'change-password-title': 'Change password',
            'current-password-label': 'Current password',
            'new-password-label': 'New password',
            'confirm-password-label': 'Confirm the new mot de passe',
        },
        error: {
            'session-expired': 'Your session has expired, you will be disconnected for security reasons.',
        },
        page: {
            planning: {
                joyride: {
                    body: {
                        title: 'Hours & Prices',
                        content: 'A short guided tour to help you find your way and not miss anything!',
                    },
                    'help-btn': {
                        title: 'Guide Me Button',
                        content: 'This button restarts the guided tour.',
                    },
                    'planning-holidays': {
                        title: 'School Holidays Schedule',
                        content: 'This schedule corresponds to the available sessions during school holidays.',
                    },
                    'planning-summer': {
                        title: 'Summer Vacation Schedule',
                        content: 'This schedule corresponds to the available sessions during summer vacation.',
                    },
                    legend: {
                        title: 'The Legend',
                        content: 'Each schedule contains a legend that will help you better understand the schedule.',
                    },
                    planning: {
                        title: 'Main Schedule',
                        content:
                            'This schedule corresponds to the main sessions that will take place throughout the year.',
                    },
                    try: {
                        title: 'Trial sessions',
                        content: "If you're a newcomer, this should interest you!",
                    },
                    'our-prices': {
                        title: 'Our licences',
                        content:
                            'Once you have done at least one trial session, you can ask us for the registration form. On this form, you can choose the licence that suits you best and the method of payment you prefer.',
                    },
                },
                'summer-sessions':
                    "Summer sessions are open to everyone during the summer holidays. It's a good time to come and try out and have some fun with us on the courts.",
            },
            contact: {
                title: 'Contact us',
            },
            price: {
                title: 'Prices for the {{season}} season',
                'title-try': 'Try-out sessions',
                'price-try-1':
                    "You need to contact the club by email or phone, you can find them on the <a href='{{contactLink}}'>Contact us</a> page.",
                'price-try-2': 'We can lend you rackets and shuttlecocks for these occasions.',
                'price-try-3': "Beyond that, you'll need to bring your own rackets and shuttlecocks.",
                'register-info-date':
                    'Registrations will open on 1 August for renewals of existing members. And from 2 September {{registrationYear}} for new members.',
                'register-info-competition': 'All our licences allow you to take part in competitions.',
                'warning-off-day': '⚠️ Please note: The club is always closed on public holidays ! ⚠️',
            },
            competition: {
                title: 'Tournaments',
                'badnet-register': 'Sing up on BadNet',
                'tournament-account-register': 'Sing up with tournament account',
                'need-login': 'To use your tournament account you have to log in',
                'no-data': 'No tournaments yet. We will add them shortly.',
            },
            login: {
                connexion: 'Login',
                member: 'Member',
                coach: 'Coach',
                admin: 'Administrator',
                'account-type': 'Account type',
                'select-account-type': 'Select an account type',
                'connection-success': 'Connection successful',
                'go-to-member-space': 'Go to member space',
                'go-to-coach-space': 'Go to coach space',
                'go-to-admin-space': 'Go to admin space',
                'forgot-password': 'Forgot password?',
                'reset-password': 'Reset password',
                'reset-password-email-sent': 'A reset email has been sent',
                'send-email': 'Send',
                pseudo: 'Username',
                'enter-pseudo': 'Enter your username',
                'pseudo-placeholder': 'Your username',
                'pseudo-received-by-email': 'Username * (received by email)',
                'enter-email': 'Enter your email',
                'enter-email-or-pseudo': 'Enter your email or username',
                'enter-password': 'Enter your password',
                email: 'Email address',
                'email-placeholder': 'Enter your email address',
                password: 'Password',
                'email-label': 'Email',
                'email-or-pseudo': 'Email or username',
                connect: 'Sign in',
            },
        },
        joyride: {
            help: 'Guide me !',
            next: 'Next',
            last: 'End Tour',
            skip: 'Close',
            back: 'Previous',
            close: 'Close',
        },
        bot: {
            init: 'Hello! What can I do for you? You can ask me short questions or use keywords. For example, the word "schedules" will redirect you to the schedules and prices section. For longer messages, please contact the BVA at the following e-mail address: contact@bva-club.fr',
        },
        cookies:
            'This website uses cookies that last only one day in order to measure the number of visitors to improve the use of this site.',
        skill: { TO_DISCOVER: 'To discover', STARTED: 'Started', CONFIRMED: 'Confirmed', MASTERED: 'Mastered' },
    }
}

export default gbTranslation
